export type Color = "danger" | "success" | "warning" | "primary" | "secondary";

type UserInactive = 0;
type UserActive = 1;
type UserActivationPending = 2;
type UserPendingApproval = 3;
type UserPendingCellPhoneValidation = 4;

export type UserStatus =
  | UserInactive
  | UserActive
  | UserActivationPending
  | UserPendingApproval
  | UserPendingCellPhoneValidation;

export const USER_STATUS_INACTIVE: UserInactive = 0;
export const USER_STATUS_ACTIVE: UserActive = 1;
export const USER_STATUS_ACTIVATION_PENDING: UserActivationPending = 2;
export const USER_STATUS_PENDING_APPROVAL: UserPendingApproval = 3;
export const USER_STATUS_PENDING_CELL_PHONE_VALIDATION: UserPendingCellPhoneValidation = 4;

export const USER_STATUS_CONTENT: Record<UserStatus, string> = {
  [USER_STATUS_INACTIVE]: "Inativo",
  [USER_STATUS_ACTIVE]: "Ativo",
  [USER_STATUS_ACTIVATION_PENDING]: "Pendente de ativação",
  [USER_STATUS_PENDING_APPROVAL]: "Pendente de aprovação",
  [USER_STATUS_PENDING_CELL_PHONE_VALIDATION]: "Pendente de validação celular",
};

export const USER_STATUS_COLOR: Record<UserStatus, Color> = {
  [USER_STATUS_INACTIVE]: "danger",
  [USER_STATUS_ACTIVE]: "success",
  [USER_STATUS_ACTIVATION_PENDING]: "warning",
  [USER_STATUS_PENDING_APPROVAL]: "primary",
  [USER_STATUS_PENDING_CELL_PHONE_VALIDATION]: "secondary",
};
